export default __webpack_public_path__ + "static/media/3.a3b71ee5.jpg";